@if (initialized) {
  <mat-tab-group>
    <mat-tab label="Delivery">
      <div>&nbsp;</div>
      <ng-container matTabContent *ngTemplateOutlet="DeliverySummary"></ng-container>
    </mat-tab>
    <mat-tab label="Usage">
      <div>&nbsp;</div>
      <ng-container matTabContent *ngTemplateOutlet="UsageSummary"></ng-container>
    </mat-tab>
  </mat-tab-group>
}


<ng-template #DeliverySummary>
  @for (site of sites; track site) {
    <div>
      @if (!isSingleReport) {
        <div class="mat-body-2">SITE {{site.name}}</div>
      }
      <div class="cards-container">
        @if (!isSingleReport && !site.delivery.bs.length && !site.delivery.ms.length) {
          <div class="mat-body-2"
            >
            Found no data
          </div>
        }
        <div class="v-cards">
          <!-- Materials summary -->
          @for (ms of site.delivery.ms; track ms) {
            <div class="card link"
              (click)="openRMD(ms.rmd, 'delivery')">
              <div class="mat-subtitle-1">{{ms.material.name}}</div>
              <div class="sub-item">
                <div class="caption">
                  Received@if (ms.material.uom) {
                  <span> ({{ms.material.uom}})</span>
                  }:
                  {{ms.rmd?.received}}
                </div>
              </div>
            </div>
          }
          <!-- /Materials summary -->
          <!-- Biditems summary -->
          @for (bs of site.delivery.bs; track bs) {
            <div class="card link"
              (click)="openRMD(bs.headerItem, 'delivery')">
              <div class="mat-subtitle-1">{{bs.biditem.item}}</div>
              <div class="caption">{{bs.biditem.description}}</div>
              @if (bs.biditem.uom) {
                <div class="caption muted">UOM: ({{bs.biditem.uom}})</div>
              }
              @for (li of bs.lineItems; track li) {
                <div class="sub-item">
                  <div class="mat-body-strong">{{li.material?.name}}</div>
                  <div class="caption">
                    Received@if (li.material?.uom) {
                    <span> ({{li.material.uom}})</span>
                    }:
                    {{li.received}}
                  </div>
                </div>
              }
              <div class="sub-item">
                @if (bs.headerItem) {
                  <div class="caption">
                    QTY@if (bs.biditem.uom) {
                    <span> ({{bs.biditem.uom}})</span>
                    }:
                    {{bs.headerItem?.quantity}}
                  </div>
                }
              </div>
            </div>
          }
          <!-- /Biditems summary -->
        </div>
      </div>
    </div>
  }
</ng-template>

<ng-template #UsageSummary>

  @for (site of sites; track site) {
    <div>
      @if (!isSingleReport) {
        <div class="mat-body-2">SITE {{site.name}}</div>
      }
      <div class="cards-container">
        @if (!isSingleReport && !site.usage.bs.length && !site.usage.ms.length) {
          <div class="mat-body-2"
            >
            Found no data
          </div>
        }
        <div class="v-cards">
          <!-- Materials summary -->
          @for (ms of site.usage.ms; track ms) {
            <div class="card link" (click)="openRMD(ms.rmd, 'usage')">
              <div class="mat-subtitle-1">{{ms.material.name}}</div>
              <div class="sub-item">
                <div class="caption">
                  Used@if (ms.material.uom) {
                  <span> ({{ms.material.uom}})</span>
                  }:
                  {{ms.rmd?.used}}
                </div>
              </div>
            </div>
          }
          <!-- /Materials summary -->
          <!-- Biditems summary -->
          @for (bs of site.usage.bs; track bs) {
            <div class="card link" (click)="openRMD(bs.lineItems[0], 'usage')">
              <div class="mat-subtitle-1">{{bs.biditem.item}}</div>
              <div class="caption">{{bs.biditem.description}}</div>
              @if (bs.biditem.uom) {
                <div class="caption muted">UOM: ({{bs.biditem.uom}})</div>
              }
              @for (li of bs.lineItems; track li) {
                <div class="sub-item">
                  <div class="mat-body-strong">{{li.material?.name}}</div>
                  <div class="caption">
                    Used@if (li.material?.uom) {
                    <span> ({{li.material.uom}})</span>
                    }:
                    {{li.used}}
                  </div>
                </div>
              }
            </div>
          }
          <!-- /Biditems summary -->
        </div>
      </div>
    </div>
  }
</ng-template>